// @flow

import type { Merchant } from './types';
import { getCustomMerchantName } from './get-custom-merchant-name';

export function getName(merchant: Merchant): string {
  return getCustomMerchantName(merchant) || merchant.name;
}
